// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"7d661ae8","422":"cfe1047f","777":"c0c97846"}[chunkId] + ".chunk.js";
};